import { render, staticRenderFns } from "./zzDetail.vue?vue&type=template&id=f77f38c2&"
import script from "./zzDetail.vue?vue&type=script&lang=js&"
export * from "./zzDetail.vue?vue&type=script&lang=js&"
import style0 from "./zzDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports